import { API_URL } from "../lib/constants";
import fetchWithRequestId from "./common";

export const getyMyEntry = (accessToken) => {
  return fetchWithRequestId(`${API_URL}/entries`, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then(async (res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const getUserEntry = (accessToken, userId) => {
  return fetchWithRequestId(`${API_URL}/entries?userId=${userId}`, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then(async (res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const checkDuplicates = (
  accessToken,
  poolId: string,
  players: any[],
) => {
  const request = {
    pool: poolId,
    player1: players[0].id,
    player2: players[1].id,
    player3: players[2].id,
    player4: players[3].id,
  };
  return fetch(`${API_URL}/entries/duplicate`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  }).then(async (res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const replaceEntriesRequest = (accessToken, tournamentId, playerId) => {
  return fetch(
    `${API_URL}/entries/replace?tournamentId=${tournamentId}&playerId=${playerId}`,
    {
      method: "POST",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    },
  ).then(async (res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};
